import './style.less';

export default function($log, AuthClass) {
  'ngInject';

  const vm = this;
  this.$onInit = activate;

  vm.year = new Date().getFullYear();
  vm.prolaeraLogo = '//d4znxc3tx8unj.cloudfront.net/prolaeraLogo.png';

  function activate() {
    $log.debug('Users registration controller activated');
    AuthClass.getAuthenticationUrlPromise
      .then(({ login_url }) => {
        vm.login_url = login_url;
      })
      .catch(error => {
        this.$log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/register/index.js